import { jsx } from "react/jsx-runtime";
import { ModuleSettingsStore } from "../../../utils/contentstack/moduleSettingsStore.js";
import { getSwappedImageDomainUrl } from "../../../utils/images/lib.js";
const BODY_CONTENT_KEY = "popupVisitExternalLink.bodyContent";
const TITLE_CONTENT_KEY = "popupVisitExternalLink.titleContent";
const PRIMARY_BUTTON_KEY = "popupVisitExternalLink.primaryButtonContent";
const SECONDARY_BUTTON_KEY = "popupVisitExternalLink.secondaryButtonContent";
const CLOSE_BUTTON_ARIA_LABEL_KEY = "popupVisitExternalLink.closeButtonAriaLabel";
const parseLinkModuleSettings = (externalLinkModule) => {
  if (!externalLinkModule.composable_window.length) return null;
  const msStore = new ModuleSettingsStore({
    composable_window: externalLinkModule.composable_window,
    key_value: externalLinkModule.key_value
  });
  return {
    warningCloseButtonAriaLabelText: msStore.getComposableWindowItem(
      CLOSE_BUTTON_ARIA_LABEL_KEY
    ),
    warningPrimaryButtonText: msStore.getComposableWindowItem(PRIMARY_BUTTON_KEY),
    warningSecondaryButtonText: msStore.getComposableWindowItem(SECONDARY_BUTTON_KEY),
    warningText: msStore.getComposableWindowItem(BODY_CONTENT_KEY),
    warningTitle: msStore.getComposableWindowItem(TITLE_CONTENT_KEY)
  };
};
function renderImageIcon(entry, imageDomainSwapConfig) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  const originalSrc = ((_b = (_a = entry == null ? void 0 : entry.icon_image) == null ? void 0 : _a[0]) == null ? void 0 : _b.url) ? (_d = (_c = entry == null ? void 0 : entry.icon_image) == null ? void 0 : _c[0]) == null ? void 0 : _d.url : (_e = entry.icon) == null ? void 0 : _e.url;
  const swappedSrc = getSwappedImageDomainUrl(
    originalSrc,
    imageDomainSwapConfig
  );
  if (((_g = (_f = entry.icon_image) == null ? void 0 : _f[0]) == null ? void 0 : _g.dimensions) || ((_h = entry.icon) == null ? void 0 : _h.dimension)) {
    return /* @__PURE__ */ jsx(
      "img",
      {
        alt: entry.link_alt_text,
        loading: "lazy",
        src: swappedSrc,
        height: ((_j = (_i = entry.icon_image) == null ? void 0 : _i[0]) == null ? void 0 : _j.dimensions.height) ? (_l = (_k = entry.icon_image) == null ? void 0 : _k[0]) == null ? void 0 : _l.dimensions.height : (_m = entry.icon) == null ? void 0 : _m.dimension.height,
        width: ((_o = (_n = entry.icon_image) == null ? void 0 : _n[0]) == null ? void 0 : _o.dimensions.width) ? (_q = (_p = entry.icon_image) == null ? void 0 : _p[0]) == null ? void 0 : _q.dimensions.width : (_r = entry.icon) == null ? void 0 : _r.dimension.width
      }
    );
  } else {
    return /* @__PURE__ */ jsx("img", { alt: entry.link_alt_text, loading: "lazy", src: swappedSrc });
  }
}
export {
  parseLinkModuleSettings,
  renderImageIcon
};
